import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';

import Job from '@pages/job';
import Error from '@pages/error';

import { JobPostingJsonLd } from 'next-seo';
import { withApollo } from '../graphql/apollo';
import { withTranslation, i18n } from '../i18n';

import jobQuery from '../graphql/queries/job.graphql';

const {
  publicRuntimeConfig: { ACTIVE_SITE_HANDLE }
} = getConfig();

const JobPage = ({ data, site }) =>
  data && data.entry ? (
    <>
      <JobPostingJsonLd
        datePosted={data.entry.postDate}
        description={data.entry.embedsCopy.replace(/(\r\n|\n|\r)/gm, '').replace(/"/g, '\\"')}
        hiringOrganization={{
          name: data.entry.companies[0] && data.entry.companies[0].title,
          sameAs: data.entry.companies[0] && data.entry.companies[0].website
        }}
        jobLocation={{
          streetAddress:
            data.entry.locations[0] &&
            `${data.entry.locations[0].address.parts.address} ${data.entry.locations[0].address.parts.number}`,
          addressLocality: data.entry.locations[0] && data.entry.locations[0].address.parts.city,
          addressRegion: data.entry.locations[0] && data.entry.locations[0].address.parts.state,
          postalCode: data.entry.locations[0] && data.entry.locations[0].address.parts.postcode,
          addressCountry: data.entry.locations[0] && data.entry.locations[0].address.parts.country
        }}
        title={data.entry.title}
      />
      <Job site={site} data={data} />
    </>
  ) : (
    <Error statusCode={404} site={site} />
  );

JobPage.getInitialProps = async ctx => {
  const {
    req,
    query: { slug },
    apolloClient
  } = ctx;

  const { language } = req || i18n;
  const site = `${ACTIVE_SITE_HANDLE}${language.toUpperCase()}`;

  const { data, error } = await apolloClient.query({
    query: jobQuery,
    variables: { site, slug }
  });

  if ((data && !data.entry) || error) {
    if (ctx.res) {
      ctx.res.statusCode = 404;
    }
  }

  return {
    namespacesRequired: ['common'],
    site,
    data
  };
};

JobPage.propTypes = {
  site: PropTypes.string.isRequired,
  data: PropTypes.shape().isRequired
};

JobPage.defaultProps = {};

export default withApollo(withTranslation('common')(JobPage));
